import { patchAssignmentSchema } from "./patch-assignment.schema";

export const deleteAssignmentSchema = patchAssignmentSchema;
